import { PRODUCT_NAMES } from 'frontend-utils/utils/constants/constant-values';

export const SHARED_ROUTES = {
  PARITY_LIST: 'hotel.parity.list',
} as const;

export const ROUTE_DICT = {
  application_loading: [PRODUCT_NAMES.PRODUCT_ANY],
  'destination.settings.theme': [PRODUCT_NAMES.PRODUCT_ANY],
  'hotel.overview': [PRODUCT_NAMES.PRODUCT_ANY],
  'hotel.rates': [PRODUCT_NAMES.PRODUCT_RATE_INSIGHT],
  'hotel.events': [PRODUCT_NAMES.PRODUCT_ANY],
  'hotel.parity.insight': [PRODUCT_NAMES.PRODUCT_PARITY_INSIGHT], // PI specific
  [SHARED_ROUTES.PARITY_LIST]: [
    PRODUCT_NAMES.PRODUCT_PARITY_INSIGHT,
    PRODUCT_NAMES.PRODUCT_RATE_INSIGHT,
  ], // Shared between PI and RI
  'hotel.parity': [PRODUCT_NAMES.PRODUCT_RATE_INSIGHT], // Default to Rate Insight
  'hotel.ranking': [PRODUCT_NAMES.PRODUCT_RATE_INSIGHT],
  'hotel.short-term-rental': [PRODUCT_NAMES.PRODUCT_RATE_INSIGHT],
  'hotel.strategy': [PRODUCT_NAMES.PRODUCT_RATE_INSIGHT],
  'hotel.benchmark-insight.upsell': [
    PRODUCT_NAMES.PRODUCT_BENCHMARK_INSIGHT_UPSELL,
  ],
  'hotel.benchmark-insight': [PRODUCT_NAMES.PRODUCT_BENCHMARK_INSIGHT],
  'hotel.benchmark': [PRODUCT_NAMES.PRODUCT_RATE_INSIGHT],
  'hotel.bi-upsell': [PRODUCT_NAMES.PRODUCT_BUSINESS_INTELLIGENCE_UPSELL],
  'hotel.revenue-insight': [PRODUCT_NAMES.PRODUCT_REVENUE_INSIGHT],
  'hotel.market-insight-upsell': [PRODUCT_NAMES.PRODUCT_MARKET_INSIGHT_UPSELL],
  'hotel.market-insight-unsupported-market': [
    PRODUCT_NAMES.PRODUCT_MARKET_INSIGHT_UNSUPPORTED_MARKET,
  ],
  'hotel.market-insight': [PRODUCT_NAMES.PRODUCT_MARKET_INSIGHT],
  'market.marketrates': [PRODUCT_NAMES.PRODUCT_RATE_INSIGHT],
  'market.parity.insight': [PRODUCT_NAMES.PRODUCT_PARITY_INSIGHT],
  'market.parity.parity-manager': [PRODUCT_NAMES.PRODUCT_PARITY_INSIGHT],
  'market.parity.strategy': [PRODUCT_NAMES.PRODUCT_PARITY_INSIGHT],
  'market.revenue-insight': [PRODUCT_NAMES.PRODUCT_REVENUE_INSIGHT],
  'market.smart-insights': [PRODUCT_NAMES.PRODUCT_SMART_INSIGHTS],
  'hotel.pricing-manager': [PRODUCT_NAMES.PRODUCT_PRICING_MANAGER],
  'hotel.settings.competitors.benchmark': [
    PRODUCT_NAMES.PRODUCT_BENCHMARK_INSIGHT,
  ],
  'hotel.settings.competitors.general': [
    PRODUCT_NAMES.PRODUCT_RATE_INSIGHT,
    PRODUCT_NAMES.PRODUCT_MARKET_INSIGHT,
  ],
  'hotel.settings.activity': [PRODUCT_NAMES.PRODUCT_ANY],
  'hotel.settings.competitors': [PRODUCT_NAMES.PRODUCT_ANY],
  'hotel.settings.personal': [PRODUCT_NAMES.PRODUCT_ANY],
  'hotel.settings.security': [PRODUCT_NAMES.PRODUCT_ANY],
  'hotel.settings.theme': [PRODUCT_NAMES.PRODUCT_ANY],
  'hotel.settings.reports': [PRODUCT_NAMES.PRODUCT_ANY],
  'hotel.settings.hotels': [PRODUCT_NAMES.PRODUCT_ANY],
  'market.settings.personal': [PRODUCT_NAMES.PRODUCT_ANY],
  'market.settings.security': [PRODUCT_NAMES.PRODUCT_ANY],
  'market.settings.reports': [PRODUCT_NAMES.PRODUCT_ANY],
  'market.settings.hotels': [PRODUCT_NAMES.PRODUCT_ANY],
  'hotel.settings.central-mapping': [PRODUCT_NAMES.PRODUCT_CENTRAL_MAPPING],
  'hotel.settings.mapping.benchmark': [PRODUCT_NAMES.PRODUCT_BENCHMARK_INSIGHT],
  'hotel.settings.myotb': [PRODUCT_NAMES.PRODUCT_REVENUE_INSIGHT],
  'hotel.settings.pms-integration': [PRODUCT_NAMES.PRODUCT_PRICING_MANAGER],
  'hotel.settings.preferred-rate': [PRODUCT_NAMES.PRODUCT_PRICING_MANAGER],
  'hotel.settings.recommendations': [PRODUCT_NAMES.PRODUCT_PRICING_MANAGER],
  'hotel.settings.autopilot': [PRODUCT_NAMES.PRODUCT_PRICING_MANAGER],
  'hotel.settings.pos': [PRODUCT_NAMES.PRODUCT_RATE_INSIGHT],
  'hotel.settings.spider': [PRODUCT_NAMES.PRODUCT_BUSINESS_INTELLIGENCE],
  'hotel.settings.budget': [PRODUCT_NAMES.PRODUCT_BUSINESS_INTELLIGENCE],
  'hotel.settings.forecast': [PRODUCT_NAMES.PRODUCT_BUSINESS_INTELLIGENCE],
  'hotel.settings.taxes': [PRODUCT_NAMES.PRODUCT_RATE_INSIGHT],
  'hotel.snapshot': [PRODUCT_NAMES.PRODUCT_BUSINESS_INTELLIGENCE],
  'hotel.day-by-day': [PRODUCT_NAMES.PRODUCT_BUSINESS_INTELLIGENCE],
  'hotel.segment-drilldown': [PRODUCT_NAMES.PRODUCT_BUSINESS_INTELLIGENCE],
  'hotel.accounts': [PRODUCT_NAMES.PRODUCT_BUSINESS_INTELLIGENCE],
  'hotel.revpak': [PRODUCT_NAMES.PRODUCT_BUSINESS_INTELLIGENCE],
  'hotel.forecast-budget': [PRODUCT_NAMES.PRODUCT_BUSINESS_INTELLIGENCE],
  'hotel.revpak-exports': [PRODUCT_NAMES.PRODUCT_BUSINESS_INTELLIGENCE],
  'hotel.error': [PRODUCT_NAMES.PRODUCT_ANY],
  'hotel.channel-pricing': [PRODUCT_NAMES.PRODUCT_SMART_DISTRIBUTION],
  'hotel.budget': [PRODUCT_NAMES.PRODUCT_BUSINESS_INTELLIGENCE],
  'hotel.forecast': [PRODUCT_NAMES.PRODUCT_BUSINESS_INTELLIGENCE],
  'hotel.reviews': [PRODUCT_NAMES.PRODUCT_REVIEW_MANAGER],
  'hotel.account-selection': [PRODUCT_NAMES.PRODUCT_ANY],
  'market.error': [PRODUCT_NAMES.PRODUCT_ANY],
  'market.executive': [PRODUCT_NAMES.PRODUCT_BUSINESS_INTELLIGENCE],
  'market.segment-drilldown': [PRODUCT_NAMES.PRODUCT_BUSINESS_INTELLIGENCE],
  'market.heatmap': [PRODUCT_NAMES.PRODUCT_BUSINESS_INTELLIGENCE],
  'market.revpak-exports': [PRODUCT_NAMES.PRODUCT_BUSINESS_INTELLIGENCE],
  'market.snapshots': [PRODUCT_NAMES.PRODUCT_BUSINESS_INTELLIGENCE],
  'market.total-revenue': [PRODUCT_NAMES.PRODUCT_TOTAL_REVENUE],
  'market.settings.theme': [PRODUCT_NAMES.PRODUCT_ANY],
  'market.settings.transaction-mapping': [PRODUCT_NAMES.PRODUCT_TOTAL_REVENUE],
  'market.settings.property-tags': [
    PRODUCT_NAMES.PRODUCT_BUSINESS_INTELLIGENCE,
  ],
  'market.settings.cost': [PRODUCT_NAMES.PRODUCT_BUSINESS_INTELLIGENCE],
  destination: [PRODUCT_NAMES.PRODUCT_DMO],
  'hotel.settings.currency-conversion': [PRODUCT_NAMES.PRODUCT_CUSTOM_CURRENCY],
  'market.settings.central-mapping': [PRODUCT_NAMES.PRODUCT_CENTRAL_MAPPING],
  'market.settings.currency-conversion': [
    PRODUCT_NAMES.PRODUCT_CUSTOM_CURRENCY,
  ],
  'spider-portfolio': [PRODUCT_NAMES.PRODUCT_BUSINESS_INTELLIGENCE],
} as const;
